import { render, staticRenderFns } from "./App_sc1.vue?vue&type=template&id=9e58ac0c&scoped=true&"
import script from "./App_sc1.vue?vue&type=script&lang=js&"
export * from "./App_sc1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e58ac0c",
  null
  
)

export default component.exports